<!-- 发票管理详情 -->
<template>
  <div class="backborder2 container">
    <!-- 标题 -->
    <div class="section-title">发票申请详情</div>

    <!-- 详情信息 -->
    <div class="details-section">
      <div class="detail-item">
        <span class="label">发票类型：</span>{{ info.invoice_type == 1 ? '普通发票' : '专用发票' }}
      </div>
      <div class="detail-item">
        <span class="label">发票内容：</span>商品明细
      </div>
      <div class="detail-item">
        <span class="label">抬头类型：</span>{{ info.head_invoice_type == 1 ? '个人' : '单位' }}
      </div>
      <div class="detail-item">
        <span class="label">发票抬头：</span>{{ info.name }}
      </div>
      <div class="detail-item">
        <span class="label">开票金额：</span>¥{{ info.amount }}
      </div>
      <div class="detail-item">
        <span class="label">收票邮箱：</span>{{ info.email }}
      </div>
      <div class="detail-item">
        <span class="label">纳税人识别号：</span>{{ info.tax_number }}
      </div>
      <div class="detail-item">
        <span class="label">注册地址：</span>{{ info.address }}
      </div>
      <div class="detail-item">
        <span class="label">注册电话：</span>{{ info.phone }}
      </div>
      <div class="detail-item">
        <span class="label">开户银行：</span>{{ info.deposit_bank }}
      </div>
      <div class="detail-item">
        <span class="label">银行卡号：</span>{{ info.bank_account }}
      </div>
      <div class="detail-item">
        <span class="label">申请人：</span>{{ info.clerk_name }}
      </div>
      <div v-if="info.hedging_file_url" class="detail-item">
        <span class="label">对冲发票：</span>
        <el-button type="text" icon="el-icon-view"
          @click="downloadInvoice(info.hedging_file_url, info.hedging_file_name)">
          {{ this.info.hedging_file_name }}
        </el-button>
      </div>
    </div>

    <!-- 分割线 -->
    <div class="line"></div>

    <!-- 表格 -->
    <el-table :data="info.order_info" border class="order-table">
      <el-table-column prop="documents" label="订单编号"></el-table-column>
      <el-table-column prop="customer_name" label="客户名称"></el-table-column>
      <el-table-column prop="total" label="订单金额"></el-table-column>
      <el-table-column prop="inputtime" label="订单时间"></el-table-column>
      <el-table-column prop="status" label="订单状态">
        <template slot-scope="scope">
          <el-tag type="default" v-if="scope.row.status == 0">未审核</el-tag>
          <el-tag type="success" v-if="scope.row.status == 1">已审核</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">已出库</el-tag>
          <el-tag type="danger" v-if="scope.row.status == 3">已撤单</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分割线 -->
    <div class="line"></div>

    <!-- 审核选项 -->
    <div class="review-options">
      <span class="label">审核：{{ info.status == 0 ? '' : info.status == 1 ? '已开票' : info.status == 2 ? '已驳回' :
        '已退票'}}</span>
      <el-radio-group v-if="info.status == 0" v-model="reviewStatus">
        <el-radio label="通过">通过</el-radio>
        <el-radio label="驳回">驳回</el-radio>
      </el-radio-group>
    </div>
    <div v-if="info.status == 2" class="review-options">
      <span class="label">驳回原因：{{ info.reason }}</span>
    </div>
    <!-- 条件显示文本域或上传按钮 -->
    <div v-if="reviewStatus == '驳回'" class="reason-section">
      <el-input type="textarea" v-model="rejectionReason" :rows="3" placeholder="请输入驳回原因"></el-input>
    </div>

    <div v-if="reviewStatus == '通过' && info.status == 0" class="upload-section">
      <span class="label">上传发票：</span>
      <!-- 使用隐藏的input和按钮分离 -->
      <input type="file" ref="fileInput" style="display: none" @change="handleFileChange" accept=".pdf">
      <el-button type="primary" :loading="uploading" @click="triggerFileInput">
        {{ uploadButtonText }}
      </el-button>

      <!-- 上传结果展示 -->
      <div v-if="fileName" class="file-info">
        <span class="file-name">{{ fileName }}</span>
        <el-tag :type="uploadStatusType" size="small">
          {{ uploadStatusText }}
        </el-tag>
        <el-button v-if="invoiceFileUrl" type="text" icon="el-icon-download"
          @click="downloadInvoice(invoiceFileUrl, fileName)">
          预览
        </el-button>
        <el-button v-if="invoiceFileUrl" type="text" icon="el-icon-delete" @click="confirmDeleteFile">
          删除
        </el-button>
      </div>
    </div>
    <div v-if="info.status != 0 && info.status != 2" class="upload-section">
      <span class="label">发票文件：</span>

      <!-- 上传结果展示 -->
      <div class="file-info">
        <el-button v-if="invoiceFileUrl" type="text" icon="el-icon-view"
          @click="downloadInvoice(info.file_url, info.file_name)">
          {{ info.file_name }}
        </el-button>
      </div>
    </div>

    <!-- 情况1：审核通过时显示输入框 -->
    <div v-if="reviewStatus == '通过' && info.status == 0" class="reason-section" style="margin-top: 20px;">
      <span style="margin-bottom: 10px;"><span class="label">备注：</span></span>
      <el-input 
        type="textarea" 
        v-model="content" 
        :rows="3" 
        placeholder="请输入备注信息（选填）"
        maxlength="200"
        show-word-limit>
      </el-input>
    </div>

    <!-- 情况2：非待审核状态，显示可编辑备注 -->
    <div v-if="info.status != 0" class="reason-section" style="margin-top: 20px;">
      <span style="margin-bottom: 10px;"><span class="label">备注：</span></span>
      <el-input 
        type="textarea" 
        v-model="content" 
        :rows="3" 
        placeholder="请输入备注信息（选填）"
        maxlength="200"
        show-word-limit>
      </el-input>
    </div>

    <!-- 按钮区域 -->
    <div class="button-section">
      <el-button @click="goBack">返回列表</el-button>
      <el-button v-if="info.status == 0" type="primary" @click="saveReview" :loading="submitLoading">保存</el-button>
      <el-button v-if="info.status != 0" type="primary" size="small" @click="updateContent" :loading="contentSaving">保存备注</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: this.GLOBAL.domain + "Invoice/detail",
      submitLoading: false,
      query: {
        token: this.$cookies.get('token'),
        id: ''
      },
      info: {
        order_info: []
      },
      reviewStatus: '通过', // 默认选中“通过”
      rejectionReason: '', // 驳回原因
      content: '', // <--- 新增：初始化备注字段
      orderList: [],

      // 文件上传相关状态
      selectedFile: null,
      invoiceFileUrl: '',
      fileName: '',
      uploading: false,
      saving: false,
      contentSaving: false
    }
  },
  computed: {
    // 上传按钮文本
    uploadButtonText() {
      return this.uploading ? '上传中...' : '选择文件';
    },

    // 上传状态展示
    uploadStatusType() {
      return this.uploading ? 'info' :
        this.invoiceFileUrl ? 'success' : 'danger';
    },

    uploadStatusText() {
      return this.uploading ? '上传中' :
        this.invoiceFileUrl ? '上传成功' : this.fileName ? '未上传' : '';
    }
  },
  methods: {
    getInfo(id) {
      this.query.id = id
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          // ... 错误处理
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          console.log(result)
          this.info = result
          this.invoiceFileUrl = result.file_url
          this.fileName = result.file_name
          this.content = result.content || '' 
        }
      })
    },
    // 触发文件选择
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    // 处理文件选择
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      // 检查文件类型
      const validTypes = ['pdf'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!validTypes.includes(fileExtension)) {
        this.$message.error('只支持PDF格式的文件');
        e.target.value = '';
        return;
      }

      // 检查文件大小（限制10MB）
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('文件大小不能超过10MB');
        e.target.value = '';
        return;
      }

      this.selectedFile = file;
      this.fileName = file.name;
      this.uploadFile(file);
    },

    // 上传文件到服务器
    uploadFile(file) {
      this.uploading = true;
      this.invoiceFileUrl = '';

      const formData = new FormData();
      formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');

      // 这里使用全局的上传URL
      const resource = this.$resource(this.GLOBAL.uploadUrl);

      resource.save(formData).then((res) => {
        // 确保响应数据存在
        if (!res.body || !res.body.Data) {
          throw new Error('上传服务返回数据格式错误');
        }

        try {
          const data = JSON.parse(Base64.decode(res.body.Data));

          if (data.Result > 0) {
            // 上传失败
            this.$message.error(data.msg || '文件上传失败');
            this.invoiceFileUrl = '';
          } else {
            // 上传成功
            this.invoiceFileUrl = this.GLOBAL.staticUrl + data.imgsrc;
            this.$message.success('文件上传成功');
          }
        } catch (error) {
          this.$message.error('解析上传结果失败: ' + error.message);
          console.error('解析错误:', error);
        }
      }).catch((error) => {
        console.error('上传请求失败:', error);
        this.$message.error('文件上传失败: ' + (error.message || '服务器错误'));
      }).finally(() => {
        this.uploading = false;
        // 清空input值以允许重新选择相同文件
        this.$refs.fileInput.value = '';
      });
    },

    // 删除已上传的文件
    confirmDeleteFile() {
      this.$confirm('确定要删除这个文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteFile();
      }).catch(() => {
        // 用户取消删除
      });
    },

    deleteFile() {
      // 这里只是前端清除状态，实际文件删除需要后端处理
      this.invoiceFileUrl = '';
      this.fileName = '';
      this.selectedFile = null;
      this.$message.success('文件已删除');
    },

    // 更新备注内容
    updateContent() {
      this.contentSaving = true;
      const resource = this.$resource(this.GLOBAL.domain + 'Invoice/update_content');
      resource.query({
        token: this.$cookies.get('token'),
        id: this.query.id,
        content: this.content
      }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          this.$message.success('备注保存成功');
          this.info.content = this.content;
        }
      }).catch(() => {
        this.$message.error('保存失败，请重试');
      }).finally(() => {
        this.contentSaving = false;
      });
    },

    // 下载已上传的发票
    downloadInvoice(url, name) {
      if (!url) {
        this.$message.warning('没有可预览的文件');
        return;
      }

      const link = document.createElement('a');
      link.href = url;
      link.download = name || '发票.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    goBack() {
      // 返回列表逻辑
      this.$emit('goBack')
    },
    // 保存审核结果
    async saveReview() {
      if (this.reviewStatus === '驳回') {
        if (!this.rejectionReason) {
          this.$message.warning('请填写驳回原因');
          return;
        }
      }

      this.saving = true;
      this.submitLoading = true

      const resource = this.$resource(this.GLOBAL.domain + 'Invoice/verify_and_save');
      resource.query({
        token: this.$cookies.get('token'),
        status: this.reviewStatus === '通过' ? 1 : 2,
        file_url: this.invoiceFileUrl,
        reason: this.rejectionReason,
        content: this.content, // <--- 新增：提交备注字段
        id: this.query.id,
        file_name: this.fileName
      }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.submitLoading = false; // 失败时记得关闭loading
          this.saving = false;
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          console.log(result, '审核发票结果')
          this.$message.success(result);
          this.submitLoading = false
          this.goBack();
        }
      }).catch(() => {
          this.submitLoading = false;
          this.saving = false;
      })
    }
  }
}
</script>

<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}
</style>
<style scoped>
.container {
  margin-top: 10px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  padding: 20px 0 10px;

}

.details-section {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}

.detail-item {
  flex: 1 1 30%;
  margin-bottom: 10px;
}

.label {
  color: #666;
}

.order-table {
  width: 100%;
  margin-top: 10px;
}

.review-options {
  margin: 20px 0;
}

.reason-section,
.upload-section {
  margin-bottom: 20px;
}

.button-section {
  text-align: right;
}

.line {
  margin: 20px 0;
  height: 1px;
  background-color: #eeeeee;
}
</style>

<style scoped>
/* 新增文件信息样式 */
.upload-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.file-info {
  margin-left: 15px;
  display: flex;
  align-items: center;
}

.file-name {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/stat/managementOfInvoicesDetails.vue